import React from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { TextLarge, TextRegular, TextSmall } from '@hz-design-system/web-ui';
import Classes from './ListingPriority.module.scss';

interface ListingPriorityProps {
  priorityProduct: string;
}

interface ListingPriorityComponentProps {
  Large: React.FC<ListingPriorityProps>;
  Small: React.FC<ListingPriorityProps>;
  Regular: React.FC<ListingPriorityProps>;
}

const ListingPriorityLarge: React.FC<ListingPriorityProps> = ({ priorityProduct }) => {
  return (
    <TextLarge color="text-success" className={Classes['hz-Listing-priority-new']}>
      <Trans tagName="span" i18nKey={`priorityProduct.${priorityProduct}`} />
    </TextLarge>
  );
};

const ListingPrioritySmall: React.FC<ListingPriorityProps> = ({ priorityProduct }) => {
  return (
    <TextSmall color="text-success" className={Classes['hz-Listing-priority-new']}>
      <Trans tagName="span" i18nKey={`priorityProduct.${priorityProduct}`} />
    </TextSmall>
  );
};

const ListingPriorityRegular: React.FC<ListingPriorityProps> = ({ priorityProduct }) => {
  return (
    <TextRegular color="text-success" className={Classes['hz-Listing-priority-new']}>
      <Trans tagName="span" i18nKey={`priorityProduct.${priorityProduct}`} />
    </TextRegular>
  );
};

const ListingPriority: ListingPriorityComponentProps = {
  Large: ListingPriorityLarge,
  Regular: ListingPriorityRegular,
  Small: ListingPrioritySmall,
};

export default ListingPriority;
